// extracted by mini-css-extract-plugin
export default {"AdSlotOffsite":"bgk_a bhj_bi"};